import { Suspense } from 'react';
import Loader from '../components/common/Loader';

export const lazyLoad = (Component) => (
	<Suspense
		fallback={
			<div className='flex justify-center items-center w-full h-full'>
				<Loader />
			</div>
		}>
		<Component />
	</Suspense>
);
